import axios from 'axios';
import { handleLogout } from '../../utils';
import { errorToast, showToast } from '../../utils/toast';
import { setLoading, setModuleLoading } from '../slices/loadingSlice';
import { store } from '../store';
import config from './../../components/config';

const baseURL = config.baseURL;

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem('token');

    if (token) {
      token = JSON.parse(localStorage.getItem('token'));
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      handleLogout();
      return;
    }
    return Promise.reject(error);
  }
);

const handleRequest =
  (method) =>
    async (url, data, config = { loading: true, module: null, toast: true, throwError: true }) => {
      if (!navigator.onLine) return;
      try {
        const { loading, module } = config;

        store.dispatch(setModuleLoading(module));
        if (loading || loading === undefined) store.dispatch(setLoading(true));

        const response = await axiosInstance.request({
          method,
          url,
          data,
          ...{ ...config, signal: config.source?.signal },
        });

        if (method !== 'get' && config.toast) {
          if (response?.data?.ack) showToast(response?.data?.message);
          else errorToast(response?.data?.message);
        } else if (!response?.data?.ack) {
          errorToast(response?.data?.message);
        }

        return config.responseType === 'blob' ? response : response?.data;
      } catch (error) {
        if (error.code === 'ERR_CANCELED') return error.code;
        if (error?.response?.status === 401) {
          handleLogout();
          return;
        } else if (error?.response?.status === 403) {
          window.location.href = '/';
        }
        errorToast(error?.response?.data?.message || 'Something went wrong.');
      } finally {
        store.dispatch(setLoading(false));
        if (module) store.dispatch(setModuleLoading(null));
      }
    };

const handleGetRequest = handleRequest('get');
const handlePostRequest = handleRequest('post');
const handlePutRequest = handleRequest('put');
const handleDeleteRequest = handleRequest('delete');
const handlePatchRequest = handleRequest('patch');

export {
  handleDeleteRequest,
  handleGetRequest,
  handlePatchRequest,
  handlePostRequest,
  handlePutRequest,
};
